import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import VoicemailIcon from '@mui/icons-material/VoicemailOutlined';
import FaxIcon from '@mui/icons-material/FaxOutlined';
import ContactsIcon from '@mui/icons-material/ContactsOutlined';
import GroupsIcon from '@mui/icons-material/GroupsOutlined';
import SmsIcon from '@mui/icons-material/SmsOutlined';
import AdminIcon from '@mui/icons-material/ManageAccountsOutlined';
import Tooltip from '@mui/material/Tooltip';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Drawer from '@mui/material/Drawer';
// import SettingsIcon from '@mui/icons-material/Settings';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutlined';
import FeedbackIcon from '@mui/icons-material/RateReviewOutlined';
import HelpOutlineIcon from '@mui/icons-material/HelpOutlined';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import HelpIcon from '@mui/icons-material/Help';
import PhoneIcon from '@mui/icons-material/PhoneOutlined';
// import MenuBookIcon from '@mui/icons-material/MenuBook';
import NotificationMenu from './notificationMenu';
import Avatar from '@mui/material/Avatar';
// import DialpadIcon from '@mui/icons-material/Dialpad';
import { connect } from 'react-redux';
import { setOpenDialer, setRemoteNumber, setStartConference, setStartTransfer } from '../store/features/user/userSlice';
import CallIndicator from './callIndicator';
import { resolveSessionNames } from '../utils/callSessions';
import { setIssueForm } from "../store/features/issueForm/issueFormSlice";
import { WebRtcContextJsSIP } from '../index';

import ListItemButton from "@mui/material/ListItemButton";

const mapDispatchToProps = {
  setOpenDialer,
  setRemoteNumber,
  setStartConference,
  setStartTransfer,
  setIssueForm,
};

const drawerWidth = 240;

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  grow: {
    flexGrow: 1,
  },
  title: {
    display: 'block',
    fontFamily: 'Y2K Neophyte',
  },
  // On a phone the menu slides over the page, so the bar stays where it is.
  appBarShift: {
    [theme.breakpoints.up('md')]: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  },
  menuButton: {
    marginRight: theme.spacing(3),
  },
  // The menu button stays on a phone, where it also closes the menu.
  hide: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  // On a phone the menu takes no room in the page: it lies over it, with
  // the page dimmed behind. Pressing the dimmed page closes the menu.
  // On a tablet held upright it keeps the room of the rail, open or closed.
  drawerDock: {
    [theme.breakpoints.down('md')]: {
      width: `calc(${theme.spacing(9)} + 1px) !important`,
    },
    [theme.breakpoints.down('sm')]: {
      width: '0 !important',
    },
  },
  drawerBackdrop: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'fixed',
      inset: 0,
      zIndex: theme.zIndex.modal,
      backgroundColor: 'rgba(0, 0, 0, 0.45)',
    },
  },
  drawer: {
    width: drawerWidth,
    maxHeight: 'calc(var(--app-vh))',
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  // Open on a phone or a tablet held upright, the menu lies over the page,
  // above everything including the tab of the section menu.
  drawerOverlay: {
    [theme.breakpoints.down('md')]: {
      '&.MuiDrawer-paper': {
        zIndex: theme.zIndex.modal + 1,
      },
    },
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: '0px',
    // Closed on a phone there is nothing to show, not even its edge.
    [theme.breakpoints.down('sm')]: {
      '&.MuiDrawer-paper': {
        borderRight: 0,
      },
    },
    // From tablet width up, the closed menu is a rail of icons.
    [theme.breakpoints.up('sm')]: {
      width: `calc(${theme.spacing(9)} + 1px)`,
    },
  },
  // A sidebar entry. The current one is tinted with an accent on the left.
  listItems: {
    marginTop: theme.spacing(1),
    minHeight: 48,
    boxShadow: 'inset 3px 0 0 transparent',
    transition: 'background-color 0.15s ease, box-shadow 0.15s ease',
    '& .MuiListItemIcon-root': {
      color: theme.palette.text.secondary,
    },
    '& .MuiListItemText-root span': {
      fontSize: 15,
    },
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '&.Mui-selected, &.Mui-selected:hover': {
      backgroundColor: 'rgba(77, 171, 245, 0.12)',
      boxShadow: `inset 3px 0 0 ${theme.palette.primary.light}`,
      '& .MuiListItemIcon-root, .MuiListItemText-root span': {
        color: theme.palette.primary.light,
      },
      '& .MuiListItemText-root span': {
        fontWeight: 500,
      },
    },
  },
  listItemIcon: {
    paddingLeft: theme.spacing(1),
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  sectionDesktop: {
    display: 'flex',
    '&>button:first-of-type': {
      marginRight: theme.spacing(1),
    },
  },
  settings: {
    marginTop: 'auto',
    marginBottom: theme.spacing(2),
  },
  accountButton: {
    position: 'relative',
    padding: 6,
  },
  avatar: {
    width: 36,
    height: 36,
    fontSize: 14,
    fontWeight: 500,
    border: '2px solid rgba(255, 255, 255, 0.85)',
  },
  // Whether the browser phone is registered: a dot on the avatar.
  avatarDot: {
    position: 'absolute',
    bottom: 5,
    right: 5,
    width: 11,
    height: 11,
    borderRadius: '50%',
    border: '2px solid #fff',
  },
  connected: {
    backgroundColor: '#3d9c4a',
  },
  disconnected: {
    backgroundColor: '#ff3636',
  },
  dialPad1Container: {
    background: theme.palette.common.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '24px',
    width: 32,
    height: 32,
  },
  dialPad1: {
    color: theme.palette.common.black,
  },
  dialPad2Container: {
    background: '#ff4a4a',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '24px',
    width: 32,
    height: 32,
  },
  dialPad2: {
    color: theme.palette.common.white,
  },
  support: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  mainMenuPaper: {
    minWidth: 248,
    marginTop: theme.spacing(0.5),
    borderRadius: 10,
    boxShadow: '0px 6px 24px rgba(0, 0, 0, 0.16)',
  },
  mainMenuHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1, 2, 1.5),
    marginBottom: theme.spacing(0.5),
    borderBottom: '1px solid ' + theme.palette.divider,
  },
  mainMenuAvatar: {
    width: 40,
    height: 40,
    fontSize: 15,
    fontWeight: 500,
    color: '#fff',
    backgroundColor: theme.palette.primary.light,
  },
  mainMenuName: {
    fontSize: 15,
    fontWeight: 500,
    lineHeight: 1.35,
    color: theme.palette.text.primary,
  },
  mainMenuDetail: {
    fontSize: 12.5,
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
  },
  mainMenuItem: {
    minHeight: 40,
    '& .MuiListItemText-root span': {
      fontSize: 14.5,
    },
  },
  mainMenuLogout: {
    borderTop: '1px solid ' + theme.palette.divider,
    paddingTop: '8px',
    marginTop: '4px',
  },
  mainMenuItemIcon: {
    minWidth: '36px',
    color: theme.palette.text.secondary,
  }
}));

const MCLAppBar = (props) => {
  const { classes, cx } = useStyles()
  const theme = useTheme()
  const path = "/dashboard"
  let location = useLocation()
  const navigate = useNavigate()
  const {
    logoutFn,
    history,
    userPhoto,
    branding,
    user,
    phonebook,
    setOpenDialer,
    setRemoteNumber,
    setIssueForm,
    services,
    setStartConference,
    setStartTransfer,
  } = props

  const [open, setOpen] = React.useState(false)
  const [notificationCount, setNotificationCount] = React.useState(0)

  // Unread SMS messages across all conversations, shown on the SMS icon.
  const unreadSmsCount = props.smsNotificationsSetting === "no" ? 0
    : (props.unreadConversations || []).reduce((sum, c) => sum + (Number(c.unreadMessages) || 0), 0)

  const [anchorEl, setAnchorEl] = React.useState(null)
  const [callSessionAnchorEl, setCallSessionAnchorEl] = React.useState(null)
  const [notifcationsAnchorEl, setNotifcationsAnchorEl] = React.useState(null)

  const isProfileMenuOpen = Boolean(anchorEl)
  const isCallSessionMenuOpen = Boolean(callSessionAnchorEl)
  const isNotificationMenuOpen = Boolean(notifcationsAnchorEl)
  const webRtcContextJsSIP = React.useContext(WebRtcContextJsSIP)
  const [sipRegistered, setSipRegistered] = React.useState(false)

  const sipRegisterCb = () => {
    setSipRegistered(webRtcContextJsSIP.getSipRegistered())
  }

  if (user.voip.active === 'yes') {
    webRtcContextJsSIP.setNotifyOnRegister(sipRegisterCb)
  }

  // Ongoing calls, shown in the bar on every page except the Phone view,
  // which already shows them.
  // With the contact's name, whichever phonebook the number is in.
  const callSessions = resolveSessionNames(
    user.sipSessions || [],
    [props.personalPhonebook, phonebook, props.externalPhonebook]
  )
  const onPhoneView = location.pathname.indexOf(`${path}/call/phone`) === 0
  const openPhoneView = () => navigate(`${path}/call/phone/all`)
  const hangUpFromBar = (number) => {
    // Same clean-up as the Phone view: a pending transfer or added call
    // that belongs to this call is abandoned with it.
    if (user.startConference === number) setStartConference(null)
    if (user.startTransfer === number) setStartTransfer(null)
    webRtcContextJsSIP.hangupSession(number)
  }
  const answerFromBar = (number) => {
    webRtcContextJsSIP.answerCall(number)
    openPhoneView()
  }

  const handleMenuOpen = (menu, event) => {
    if (menu.toLowerCase() === 'account') {
      setAnchorEl(event.currentTarget)
    } else if (menu.toLowerCase() === 'callsession') {
      setCallSessionAnchorEl(event.currentTarget)
    } else {
      setNotifcationsAnchorEl(event.currentTarget)
    }
  };

  const handleMenuClose = (menu) => {
    if (menu.toLowerCase() === 'account') {
      setAnchorEl(null)
    } else if (menu.toLowerCase() === 'callsession') {
      setCallSessionAnchorEl(null)
    } else {
      setNotifcationsAnchorEl(null)
    }
  };

  const handleLogout = () => {
    handleMenuClose('account');
    logoutFn();
  }

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const renderProfileMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id='account-menu'
      keepMounted
      open={isProfileMenuOpen}
      onClose={(e) => handleMenuClose('account')}
      slotProps={{ paper: { className: classes.mainMenuPaper } }}
    >
      <ListItem className={classes.mainMenuHeader}>
        <Avatar className={classes.mainMenuAvatar} src={userPhoto}>
          {`${user.firstName.charAt(0)}${user.lastName.charAt(0)}`}
        </Avatar>
        <div>
          <div className={classes.mainMenuName}>
            {`${user.firstName} ${user.lastName}`}
          </div>
          <div className={classes.mainMenuDetail}>
            {`Extension ${user.voicemail.mailbox}`}
            {user.voip.active === 'yes' ? (sipRegistered ? ' · Phone registered' : ' · Phone not registered') : ''}
          </div>
        </div>
      </ListItem>
      <MenuItem
        component={Link}
        to={`/dashboard/user/profile`}
        onClick={(e) => handleMenuClose('account')}
        className={classes.mainMenuItem}
      >
        <ListItemIcon className={classes.mainMenuItemIcon}>
          <PersonOutlineIcon fontSize='small' />
        </ListItemIcon>
        <ListItemText primary='My Profile' />
      </MenuItem>
      {/* <MenuItem
          disabled={true}
          component={Link}
          to={`/dashboard/user/account`}
          onClick={(e) => handleMenuClose('account')}
        >
          My Account
        </MenuItem> */}
      <MenuItem
        component={Link}
        to={`/dashboard/settings`}
        onClick={(e) => handleMenuClose('account')}
        className={classes.mainMenuItem}
      >
        <ListItemIcon className={classes.mainMenuItemIcon}>
          <SettingsOutlinedIcon fontSize='small' />
        </ListItemIcon>
        <ListItemText primary='Settings' />
      </MenuItem>
      <MenuItem
        onClick={(e) => {
          handleMenuClose('account')
          setIssueForm({ enabled: true })
        }}
        className={classes.mainMenuItem}
      >
        <ListItemIcon className={classes.mainMenuItemIcon}>
          <FeedbackIcon fontSize='small' />
        </ListItemIcon>
        <ListItemText primary='Feedback' />
      </MenuItem>
      <MenuItem
        component={Link}
        to={`/dashboard/user/help`}
        onClick={(e) => handleMenuClose('account')}
        className={classes.mainMenuItem}
      >
        <ListItemIcon className={classes.mainMenuItemIcon}>
          <HelpOutlineIcon fontSize='small' />
        </ListItemIcon>
        <ListItemText primary='Help' />
      </MenuItem>
      <MenuItem
        onClick={(e) => handleLogout(e)}
        className={cx(classes.mainMenuItem, classes.mainMenuLogout)}>
        <ListItemIcon className={classes.mainMenuItemIcon}>
          <ExitToAppIcon fontSize='small' style={{ transform: 'rotate(180deg)' }} />
        </ListItemIcon>
        <ListItemText primary='Sign out' />
      </MenuItem>
    </Menu>
  );

  const renderCallSessionMenu = (
    <Menu
      anchorEl={callSessionAnchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id='callSession-menu'
      keepMounted
      open={isCallSessionMenuOpen}
      onClose={(e) => handleMenuClose('callSession')}
    // PaperProps={{
    //   style: {
    //     minWidth: '300px'
    //   }
    // }}
    >
      {webRtcContextJsSIP.getRemoteNumbers().map(remoteNumber => {
        const contact = phonebook.find((e) => e.voicemail.mailbox === remoteNumber)
        const contactName = (contact) ? contact.firstName + ' ' + contact.lastName : remoteNumber
        return <MenuItem
          key={remoteNumber}
          onClick={(e) => {
            setRemoteNumber(remoteNumber)
            setOpenDialer(!user.openDialer)
            handleMenuClose('callSession')
          }}
        >
          <ListItemText key={'li_' + remoteNumber} primary={contactName} />
        </MenuItem>
      })}
    </Menu>
  );

  const makeDrawerMenu = () => {
    const drawerMenu = [
      (services.call && services.call === "no") ? null : {
        text: 'Calls',
        icon: <PhoneIcon />,
        link: '/call/phone/all',
      },
      (services.voicemail && services.voicemail === "no") ? null : {
        text: 'Voicemail',
        icon: <VoicemailIcon />,
        link: '/voice/mail/all',
      },
      (services.fax && services.fax === "no") ? null : {
        text: 'Fax',
        icon: <FaxIcon />,
        link: '/fax/fax/all',
      },
      (services.contacts && services.contacts === "no") ? null : {
        text: 'Contacts',
        icon: <ContactsIcon />,
        link: '/contacts/all',
      },
      (services.conference && services.conference === "no") ? null : {
        text: 'Conference',
        icon: <GroupsIcon />,
        link: '/conference/personal',
      },
      (services.sms && services.sms === "no") ? null : {
        text: 'SMS',
        icon: (
          <Badge
            color='secondary'
            max={99}
            badgeContent={unreadSmsCount > 0 ? unreadSmsCount : null}
            aria-label={unreadSmsCount > 0 ? `${unreadSmsCount} unread SMS` : undefined}
          >
            <SmsIcon />
          </Badge>
        ),
        link: '/sms/sms/all',
      },
      (services.admin && services.admin === "no") ? null : {
        text: 'Admin',
        icon: <AdminIcon />,
        link: '/admin/timeframe/all',
      },
    ];

    return drawerMenu.filter(item => item !== null)
                     .map((item) => (
        // The name of an entry, as a tooltip while only its icon shows.
        <Tooltip key={item.text} title={open ? '' : item.text} placement='right' arrow>
        <ListItemButton
          component={Link}
          to={`${path}${item.link}`}
          onClick={() => setOpen(false)}
          selected={
            location.pathname.indexOf(item.link.split('/')[1]) !== -1 &&
            location.pathname.indexOf('notifications') === -1
          }
          key={item.text}
          className={classes.listItems}>
          <ListItemIcon className={classes.listItemIcon}>
            {item.icon}
          </ListItemIcon>
          <ListItemText primary={item.text} />
        </ListItemButton>
        </Tooltip>
    ));
  }

  // const handleCallSessionIconClick = (e) => {
  //   const remoteNumbers = webRtcContextJsSIP.getRemoteNumbers()
  //   if (webRtcContextJsSIP.getInConference() || remoteNumbers.length === 1) {
  //     setRemoteNumber(remoteNumbers[0])
  //     setOpenDialer(!user.openDialer)
  //   } else {
  //     handleMenuOpen('callSession', e)
  //   }
  // }

  return (
    <div className={classes.root}>
      <AppBar
        position='fixed'
        className={cx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton
            color='inherit'
            aria-label='open drawer'
            onClick={toggleDrawer}
            edge='start'
            className={cx(classes.menuButton, {
              [classes.hide]: open,
            })}
            size="large">
            <MenuIcon />
          </IconButton>
          <Typography className={classes.title} variant='h6' noWrap>
            {branding.companyName}
          </Typography>
          <div className={classes.grow} />
          {!onPhoneView && callSessions.length > 0 && (
            <CallIndicator
              sessions={callSessions}
              onOpen={openPhoneView}
              onHangUp={hangUpFromBar}
              onAnswer={answerFromBar}
            />
          )}
          <div className={classes.sectionDesktop}>
            <IconButton
              aria-label='show new notifications'
              aria-controls='notification-menu'
              aria-haspopup='true'
              onClick={(e) => handleMenuOpen('notifications', e)}
              color='inherit'
              size="large">
              <Badge
                max={999}
                badgeContent={
                  notificationCount > 0 ? notificationCount : null
                }
                color='secondary'
              >
                <NotificationsIcon />
              </Badge>
            </IconButton>
            {/* <IconButton
              onClick={(e) => user.activeCall && handleCallSessionIconClick(e)}>
              <div className={user.activeCall ? classes.dialPad2Container : classes.dialPad1Container}>
                <DialpadIcon className={user.activeCall ? classes.dialPad2 : classes.dialPad1} />
              </div>
            </IconButton> */}
            <IconButton
              edge='end'
              aria-label='account of current user'
              aria-controls='account-menu'
              aria-haspopup='true'
              onClick={(e) => handleMenuOpen('account', e)}
              color='inherit'
              className={classes.accountButton}
              size="large">
              <Avatar className={classes.avatar} src={userPhoto}>
                {`${user.firstName.charAt(0)}${user.lastName.charAt(0)}`}
              </Avatar>
              {user.voip.active === 'yes' ?
                <span
                  className={cx(classes.avatarDot, sipRegistered ? classes.connected : classes.disconnected)}
                  title={sipRegistered ? 'Phone registered' : 'Phone not registered'}
                /> :
                null
              }
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {open ? <div className={classes.drawerBackdrop} onClick={toggleDrawer} aria-hidden='true' /> : null}
      <Drawer
        variant='permanent'
        className={cx(classes.drawer, classes.drawerDock, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: cx(classes.drawer, {
            [classes.drawerOpen]: open,
            [classes.drawerOverlay]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <IconButton onClick={toggleDrawer} size="large">
            {theme.direction === 'rtl' ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </div>
        <Divider />
        <List>{makeDrawerMenu()}</List>
        <List className={classes.settings}>
          <ListItemButton
            className={cx(classes.listItems, classes.support)}
            onClick={() => setOpen(false)}>
            <ListItemIcon className={classes.listItemIcon}>
              <HelpIcon />
            </ListItemIcon>
            <ListItemText primary='Support' />
          </ListItemButton>
          {/* <ListItem
              button
              className={classes.listItems}
              component={Link}
              to={`${path}/settings`}
              onClick={() => setOpen(false)}
              selected={
                location.pathname.indexOf('settings') !== -1
              }
            >
              <ListItemIcon className={classes.listItemIcon}>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary='Global Settings' />
            </ListItem> */}
        </List>
      </Drawer>
      {renderProfileMenu}
      {renderCallSessionMenu}

      <NotificationMenu
        isOpen={isNotificationMenuOpen}
        onCloseFunction={handleMenuClose}
        menuAnchorElement={notifcationsAnchorEl}
        badgeSetter={setNotificationCount}
        history={history}
      />
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    branding: state.branding,
    user: state.user,
    phonebook: state.phonebook,
    personalPhonebook: state.personalPhonebook,
    externalPhonebook: state.externalPhonebook,
    services: state.user.webapp.services,
    unreadConversations: state.notifications.conversation,
    smsNotificationsSetting: state.user.webapp.notifications && state.user.webapp.notifications.conversation,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MCLAppBar);